export const SET_SALES_CODE = 'SALES_CODE_MODAL.SET_SALES_CODE';
export const SHOULD_SHOW_MODAL = 'SALES_CODE_MODAL.SHOULD_SHOW_MODAL';

export enum SALES_CODE_SCENARIO {
    FROM_REGISTRATION = 'FROM_REGISTRATION',
    FROM_ACCOUNT = 'FROM_ACCOUNT',
}
